import {unEscapeOutput} from "@/helpers/element-helper";

export function generateMetaDataHtml(metaData, isStoryLine = false) {

    let metaDataHtml = '  <table class="table"><tbody>'

    // '     <div class="mb-4">\n' +
    // '                        <div class=""><h4 class="mb-1">` + metaDataGroup.Name + `</h4></div>'
    metaData.map( metaDataGroup => {
        metaDataHtml += '<tr>'
        metaDataHtml += '<td colspan="2"> <h3 class="pt-3 mb-0">' + metaDataGroup.Name + '</h3></td>'
        metaDataHtml += '</tr>'

        metaDataGroup.meta_data.map(metaData => {

            if (metaData.meta_data_geo_standard === null) {
                metaDataHtml += '<tr>'
                metaDataHtml += '<td class="w-25"><b>' + metaData.Metadata + '</b></td>'

                if(isStoryLine) {
                    metaDataHtml += '</tr><tr>'
                }
                metaDataHtml += '<td>'

                if (metaData.AttributeTypeID === 402) {
                    metaDataHtml +=  convertDate(metaData.Waarde)
                } else {
                    metaDataHtml += getMedataDataAttributeTypeValue(metaData)
                }

                metaDataHtml += '</td></tr>'
            } else {
                if (metaData.MetaDataGeoStandardID === 5) {
                    metaDataHtml = `<p>` + metaData.Waarde + `</p>` + metaDataHtml
                } else {

                    if(isStoryLine) {
                        metaDataHtml += `  <tr>
                                            <td class="w-100"><b>` + metaData.meta_data_geo_standard.Name + `</b></td>
                                            </tr><tr><td>`
                    } else {

                        metaDataHtml += `  <tr>
                                            <td class="w-40"><b>` + metaData.meta_data_geo_standard.Name + `</b></td>
                                            <td>`
                    }

                        if (metaData.MetaDataGeoStandardID === 13) {

                            const tags = metaData.Waarde.split(';')

                            tags.map((tag) => {
                                metaDataHtml += '<span class="badge badge-secondary ml-2 badge-pill">' + tag + '</span>'
                            })
                        } else {
                            metaDataHtml += getMedataDataAttributeTypeValue(metaData)
                        }

                        metaDataHtml += `</td>
                                </tr>`;
                }
            }
        })
    })

    metaDataHtml += `  </tbody></table>
                    `;
    return metaDataHtml
}

function getMedataDataAttributeTypeValue(metaData) {
    switch (metaData.AttributeTypeID) {
        case 1:
            return '<img class="showImageModal img-kv" src="' + metaData.Waarde + '"/>';
        case 3:
            return '<a target="_blank" href="' + metaData.Waarde + '">' + metaData.Waarde + '</a>';
        // Metadata
        case 404:
            return unEscapeOutput(metaData.Waarde);
        // Url
        case 405:
            return '<a target="_blank" href="mailto:' + metaData.Waarde + '">' + metaData.Waarde + '</a>';
        // Anchor
        case 406:
            const values = unEscapeOutput(metaData.Waarde).replace('<gmx:Anchor xlink:href="', '').split('">')
            const link = values[0]
            const displayName = values[1].replace('</gmx:Anchor>', '')
            return '<a target="_blank" href="' + link + '">' + displayName + '</a>';
        default:
            return metaData.Waarde
    }
}
